import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCommonAreas from 'src/SharedCustomHooks/UseCommonAreas/useCommonAreas';
import { selectPropertyById } from 'src/store/selectors/properties';
import { selectCommonAreaAssets } from 'src/store/selectors/commonAreaAssets';
import { selectServiceRequests } from 'src/store/selectors/serviceRequests';
import { fetchCommonAreaAssets } from 'src/store/actions/CommonAreaAssets';

export interface UseCommonAreaPageDataReturn {
  property: any;
  commonArea: any;
  commonAreaAssets: any[];
  serviceRequests: any[];
  loading: boolean;
}

export const useCommonAreaPageData = (
  match: any,
  locationState?: any
): UseCommonAreaPageDataReturn => {
  const dispatch: any = useDispatch();

  const commonAreaId: string = match.params.id.split('&')[0];
  const propertyId: string = match.params.id.split('&')[1];

  const hydratedCommonArea: any = locationState?.commonArea;
  const hydratedProperty: any = locationState?.property;

  const { propertyCommonAreas, loading } = useCommonAreas(propertyId);

  // TODO: replace with a useProperty(propertyId) data-fetching hook once one exists.
  // Currently depends on the `properties` redux slice being populated upstream.
  const reduxProperty: any = useSelector((state: any) =>
    selectPropertyById(state, propertyId)
  );
  const commonAreaAssets: any[] = useSelector(selectCommonAreaAssets);
  const serviceRequests: any[] = useSelector(selectServiceRequests);

  const fetchedCommonArea: any = useMemo(
    () =>
      (propertyCommonAreas?.commonAreas ?? []).find(
        (s: any) => s.id === commonAreaId
      ),
    [propertyCommonAreas, commonAreaId]
  );

  const commonArea: any = fetchedCommonArea ?? hydratedCommonArea;
  const property: any = reduxProperty ?? hydratedProperty;

  useEffect(() => {
    if (commonArea?.id) {
      dispatch(fetchCommonAreaAssets(commonArea.id));
    }
  }, [commonArea?.id]);

  return {
    property,
    commonArea,
    commonAreaAssets,
    serviceRequests,
    loading: loading && !commonArea,
  };
};

export default useCommonAreaPageData;
